<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css" />
<div class="d-flex text-center flex-column flex-column-fluid background background-cd">
  <div class="container-fluid p-5 sign-in-container rounded">
    <form [formGroup]="loginForm">
      @if(reactionOnJobOffer){
      <h1 class="opacity_text">{{ 'login.headerFromJobOffer' | translate }}</h1>
      } @if(!reactionOnJobOffer){
      <h2 class="d-flex justify-content-center logo" routerLink="">
        <img src="../../../assets/img/logo.svg" alt="sameta-logo" class="mb-3 mt-3 w-75" />
      </h2>
      } @if (!reactionOnJobOffer && candidateLogin){
      <h3 class="d-flex justify-content-center align-items-center">
        <p class="opacity_text mb-0 me-2">{{ 'login.newHereUser' | translate }}</p>
        <a routerLink="/register" data-testid="signup-link">{{ 'login.singUp' | translate }}</a>
      </h3>
      } @if (!reactionOnJobOffer && !candidateLogin){
      <h3 class="d-flex justify-content-center align-items-center">
        <p class="opacity_text mb-0 me-2">{{ 'login.newHereHR' | translate }}</p>
        <a routerLink="/register" data-testid="signup-link">{{ 'login.singUp' | translate }}</a>
      </h3>
      }
      <div class="col-sm btn btn-sm border d-flex align-items-start justify-content-center custom-btn" (click)="googleAuth()">
        <img class="me-2" alt="" src="../../../assets/img/google.svg" />
        <p class="mb-0">Use Google</p>
      </div>
      <div>
        <div class="row mt-3 mb-3 align-items-center">
          <div class="col-5 d-flex"><hr class="w-100" /></div>
          <div class="col-2 text-center middle-text opacity_text"><h3>OR</h3></div>
          <div class="col-5"><hr class="w-100" /></div>
        </div>
      </div>
      <div class="mb-3 d-flex flex-column align-items-start">
        <label class="form-label w-100 text-start">{{ 'stepperForm.personalInfo.email' | translate }}</label>
        <input
          id="email"
          type="email"
          class="form-control"
          formControlName="email"
          autocomplete="email"
          placeholder="ex. example@gmail.com"
          [ngClass]="{ 'border border-danger': loginForm.get('email')?.dirty && loginForm.get('email')?.invalid }"
          data-testid="email-input" />
      </div>
      <div class="mb-3">
        <div class="input-group">
          <div class="d-flex justify-content-between w-100">
            <label class="form-label text-start">{{ 'shared.password' | translate }}</label>
            <a (click)="forgotPassword()" class="text-end" data-testid="forgot-password-link">{{ 'login.forgotPassword' | translate }}?</a>
          </div>
          <input
            type="{{ hidePS ? 'password' : 'text' }}"
            class="form-control"
            id="password"
            formControlName="password"
            placeholder="{{ 'shared.password' | translate }}"
            autocomplete="new-password"
            [ngClass]="{ 'border border-danger': loginForm.get('password')?.dirty && loginForm.get('password')?.invalid }"
            (keydown.enter)="login()"
            data-testid="password-input" />
          <button class="btn btn-outline-secondary" type="button" (click)="toggleHidePassword('PS')" data-testid="toggle-password-button">
            <i class="bi" [ngClass]="hidePS ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>
        @if(!reactionOnJobOffer){
        <button class="btn mt-3 button-color w-100" (click)="login()" data-testid="login-button">
          {{ 'login.logIn' | translate }}
        </button>
        } @if (reactionOnJobOffer){
        <button class="btn mt-3 btn-secondary w-100" (click)="joblogin()">{{ 'login.logIn' | translate }} jobs</button>
        <div class="w-100 mt-3 d-flex flex-column">
          <div>
            <div class="row">
              <div class="col-3 d-flex"><hr class="w-100" /></div>
              <div class="col-6 text-center middle-text">
                <h3>{{ 'login.titleRegister' | translate }}</h3>
              </div>
              <div class="col-3"><hr class="w-100" /></div>
            </div>
          </div>
          <div class="d-flex flex-column center-class">
            <button (click)="jobregister()" type="button" class="success-button">{{ 'login.titleRegister' | translate }} jobs</button>
          </div>
        </div>
        }
      </div>
    </form>
  </div>
</div>
